import {
  Button,
  Card,
  Heading,
  Link,
  Stack,
  Text,
} from "@softmax/design-system";
import { spacing } from "@softmax/design-system/tokens.stylex";
import * as stylex from "@stylexjs/stylex";

export type LinkedAccount =
  | {
      readonly provider: "discord" | "github";
      readonly status: "available";
      readonly onLink: () => void;
    }
  | {
      readonly provider: "discord";
      readonly status: "linked";
      readonly profileHref: string;
      readonly communityHref: string;
    }
  | {
      readonly provider: "github";
      readonly status: "linked";
      readonly onTeamRoster: boolean;
    };

export function LinkedAccounts({
  accounts,
}: {
  readonly accounts: readonly LinkedAccount[];
}) {
  return (
    <Card>
      <Stack width="auto">
        <Heading level={2}>Linked accounts</Heading>
        {accounts.map((account) => (
          <div key={account.provider} {...stylex.props(styles.row)}>
            <div>
              <Heading level={3}>
                {account.provider === "github" ? "GitHub" : "Discord"}
              </Heading>
              {account.status === "linked" && account.provider === "github" ? (
                <Text as="p" size="small" tone="muted">
                  {account.onTeamRoster
                    ? "Linked · Softmax team membership verified."
                    : "Linked · This account is not on the Softmax team roster."}
                </Text>
              ) : null}
              {account.status === "linked" && account.provider === "discord" ? (
                <Text as="p" size="small">
                  <Link
                    focus="native"
                    href={account.profileHref}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Linked Discord account
                  </Link>{" "}
                  ·{" "}
                  <Link
                    focus="native"
                    href={account.communityHref}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Softmax community
                  </Link>
                </Text>
              ) : null}
            </div>
            {account.status === "available" ? (
              <Button type="button" onClick={account.onLink}>
                Link {account.provider === "github" ? "GitHub" : "Discord"}
              </Button>
            ) : null}
          </div>
        ))}
      </Stack>
    </Card>
  );
}
const styles = stylex.create({
  row: {
    display: "flex",
    flexWrap: "wrap",
    alignItems: "center",
    justifyContent: "space-between",
    gap: spacing.space16,
  },
});
